<h1 [ngClass]="{'asterisk' : required}">{{label}}</h1>
<div class="container">
  <form [formGroup]="addressFormGroup">
    <app-simple-autocomplete-value-accessor label="Typ adresu"
                                            formControlName="typeId"
                                            [data]="addressTypes"></app-simple-autocomplete-value-accessor>
    <div class="triple-field-container">
      <mat-form-field appearance="outline">
        <mat-label>Ulica</mat-label>
        <input matInput formControlName="street" required/>
        <mat-error *ngIf="addressFormGroup.get('street').hasError('required')">
        Podaj poprwaną ulicę
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Numer budynku</mat-label>
      <input matInput formControlName="estateNumber" required/>
      <mat-error *ngIf="addressFormGroup.get('estateNumber').hasError('required')">
        Podaj poprawny numer budynku
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Numer lokalu</mat-label>
      <input matInput formControlName="localNumber"/>
    </mat-form-field>
  </div>
  <div class="double-field-container">
    <mat-form-field appearance="outline">
      <mat-label>Kod pocztowy</mat-label>
      <input matInput maxlength="6" formControlName="postalCode" required/>
      <mat-error *ngIf="addressFormGroup.get('postalCode').hasError('required')">
        Podaj kod pocztowy miejscowości
      </mat-error>
      <mat-error *ngIf="addressFormGroup.get('postalCode').hasError('pattern')">
        Podaj kod pocztowy miejscowości w formacie XX-XXX
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Miejscowość</mat-label>
      <input matInput formControlName="city" required/>
      <mat-error *ngIf="addressFormGroup.get('city').hasError('required')">
        Podaj miescowość
      </mat-error>
    </mat-form-field>
  </div>
</form>
</div>
